export enum SettingType {
  Quota = 'quota',
  Storage = 'storage',
  AI = 'ai'
}
